import React from "react";

const Services = ({ classicHeader, darkTheme }) => {
  // services details
  const services = [
    {
      name: "Mentorship",
      desc: "Mentor engineering leaders to foster growth in business acumen and delivery proficiency.",
      icon: "fas fa-person-chalkboard",
    },
    {
      name: "Strategic Leadership ",
      desc: "Collaborate with cross-functional teams to innovate and deliver high-quality products.",
      icon: "fas fa-people-group",
    },
    {
      name: "AWS Budgets at Scale",
      desc: "The time to plan for future growth is now. Forecasting costs requires anticipating customer needs while balancing features and new service expenditures",
      icon: "fas fa-dollar-sign",
    },
    {
      name: "On-Premise to SaaS Migrations",
      desc: "Moving your customers and your development teams from an on-premise way of life into the future with SaaS is an art. ",
      icon: "fas fa-cloud",
    },
    {
      name: "Software Development Lifecycle (SDLC)",
      desc: "Defining your organization's SDLC is critical to your success. Using my proven blueprints, I can get your teams delivering high-quality code on time.",
      icon: "fa-regular fa-clipboard",
    },
    {
      name: "Mobile App Development",
      desc: "React Native cross platform app development paired with serverless backends",
      icon: "fas fa-mobile-screen",
    },
  ];

  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            Services
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            What I Do
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-sm rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      >
                        <i className={service.icon} />
                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                      >
                        {service.desc}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
